import { createStyles, makeStyles, Tab, Tabs } from "@material-ui/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { verticalIconTab } from "../../../core/theme";
import { TabContentProps } from "./TabContent";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      maxWidth: verticalIconTab.width,
      minWidth: verticalIconTab.width
    }
  })
);

export interface TabHeaderProps extends TabContentProps {
  hideLabels?: boolean;
  orientation?: "vertical";
  value: string;
  identifyTab?: (tabPath: string) => string;
}

export const TabHeader = (props: TabHeaderProps) => {
  const i18n = useTranslation();
  const classes = useStyles();
  const { baseUrl, orientation, tabs, hideLabels, value } = props;

  return (
    <Tabs
      classes={orientation === "vertical" ? classes : undefined}
      value={value}
      orientation={orientation}
      indicatorColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      style={{ marginBottom: 20 }}
    >
      {tabs.map(tab => {
        return (
          <Tab
            classes={orientation === "vertical" ? classes : undefined}
            key={tab.path}
            label={!hideLabels && i18n.t(tab.label)}
            icon={tab.icon}
            value={
              props.identifyTab
                ? props.identifyTab(baseUrl + tab.path)
                : baseUrl + tab.path
            }
            component={Link}
            to={baseUrl + tab.path}
          />
        );
      })}
    </Tabs>
  );
};
